module.exports = __webpack_public_path__ + "static/img/regirsterFinish.94aff14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regirsterFinish.jpg
// module id = oR6c
// module chunks = 1